import { useState } from 'react';

interface ProductGalleryProps {
  images: string[];
  alt: string;
}

/**
 * Simple keyboard-navigable image gallery used on the public product
 * detail page. Primary image is the first entry; the rest render as
 * thumbnails below.
 */
export default function ProductGallery({ images, alt }: ProductGalleryProps) {
  const [active, setActive] = useState(0);
  const valid = images.filter(Boolean);

  if (valid.length === 0) return null;

  const current = valid[active] ?? valid[0]!;

  return (
    <div>
      <div className="card aspect-square overflow-hidden bg-gradient-to-br from-slate-50 to-slate-100">
        <img
          src={current}
          alt={alt}
          className="h-full w-full object-contain p-8"
        />
      </div>
      {valid.length > 1 && (
        <div className="mt-3 grid grid-cols-5 gap-2">
          {valid.map((src, i) => (
            <button
              key={src + i}
              type="button"
              onClick={() => setActive(i)}
              aria-label={`View image ${i + 1}`}
              aria-pressed={i === active}
              className={`aspect-square overflow-hidden rounded-md border bg-white transition ${
                i === active
                  ? 'border-brand-500 ring-2 ring-brand-200'
                  : 'border-slate-200 hover:border-brand-300'
              }`}
            >
              <img src={src} alt="" className="h-full w-full object-contain p-2" />
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
